import ModelUtil from '@leverege/model-util';
import { Context, Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { v4 } from '@leverege/base62-util';
const {
  tf
} = I18N.ns('ui-attributes.condition.AttributeCondition');
const TYPE = 'condition.Attribute';
function create(options) {
  const opts = options || {};
  return {
    id: v4(),
    type: TYPE,
    attrName: opts.attrName || null,
    contextPath: opts.contextPath === undefined ? Context.TARGET : opts.contextPath,
    comparator: opts.comparator || null
  };
}
export default {
  type: TYPE,
  TYPE,
  create,
  name: tf('name'),
  icon: tf('conditionIcon', 'fa fa-fw fa-object-ungroup'),
  get layout() {
    return Config.get('AttributeCondition', 'layout', {
      sort: 'Attribute'
    });
  },
  handles: () => true,
  ...ModelUtil.createAllValue('attrName'),
  ...ModelUtil.createAllValue('contextPath'),
  ...ModelUtil.createAllValue('comparator')
};